export const CouponUseCases = {
  /**
   * SALES:
   *
   * - Banner Coupon Override
   * - Sticky Email Capture
   * - Product Builder
   * - Bundle Builder categories
   * - site sale
   */
  SALES: 'SALES',
  /**
   * - CDI Discount or RSA
   * - RSA Bundle
   * - RSA Ambassador
   */
  CDI: 'CDI',
} as const;
